import type {PayloadAction} from "@reduxjs/toolkit"
import {createSlice} from "@reduxjs/toolkit"

export interface PaymentProcessingState {
    merchantID: string
}

const initialState: PaymentProcessingState = {
    merchantID: "",
}

export const paymentProcessingSlice = createSlice({
    name: "paymentProcessing",
    initialState,
    reducers: {
        setMerchantID: (state, action: PayloadAction<string>) => {
            state.merchantID = action.payload
        },
    },
})

export const {setMerchantID} = paymentProcessingSlice.actions

export default paymentProcessingSlice.reducer


// WEBPACK FOOTER //
// ./src/state/payment-processor/reducer.ts